export const environment = {
  name: 'dev',
  production: false,
  apiBaseUrl: '/api',
};
